import React from "react";
import { IoAdd } from "react-icons/io5";
import DebitNoteList from "./DebitNoteList";
import DebitNoteForm from "./DebitNoteForm";
import { NavLink, useParams } from "react-router-dom";
import { hasPermission } from "../../../../../utils/permission";
import { AccessDenied } from "../../../../../shared-ui/States";

const PlusIcon = () => <IoAdd className="icon" aria-hidden="true" />;

function DebitNote() {
  const listPermission = hasPermission("ar-debit-note", "view");
  
  return (
    <div className="projects-page">
      <header className="page-header-projects">
        <div className="header-text-content">
          <h1>Debit Notes</h1>
          <p>View and manage all debit notes.</p>
        </div>
        <NavLink to="/ar/debit-notes/new">
          <button className="create-project-button-header">
            <PlusIcon /> Create New Debit Note
          </button>
        </NavLink>
      </header>
      {listPermission ? (
        <DebitNoteList />
      ) : (
        <AccessDenied description="You do not have permission to view this." />
      )}
    </div>
  );
}

export const DebitNoteFormPage = () => {
  let { id } = useParams();
  const createPermission = hasPermission("ar-debit-note", "create");
  const updatePermission = hasPermission("ar-debit-note", "set");
  
  if (id === "new") {
    if (!createPermission) {
      return (
        <AccessDenied description="You do not have permission to view this page." />
      );
    }
    id = null;
  } else {
    if (!updatePermission) {
      return (
        <AccessDenied description="You do not have permission to view this page." />
      );
    }
  }
  
  return (
    <div className="projects-page">
      <NavLink to="/ar/debit-notes">
        <button className="backbutton">Back To Debit Notes</button>
      </NavLink>
      <DebitNoteForm rowId={id} />
    </div>
  );
};

export default DebitNote;
